import { render } from './components/waveform.js';

import { initFrameAndPoll } from '@newswire/frames';

initFrameAndPoll();

let player = document.getElementById('ice-cream-truck');

const audio = window.AUDIO;

async function main() {
  render(player, audio.truck.mp3);
}

main().catch(console.error);
